<template>
	<div class="component-container">
		<div class="computer-alert" v-show="!isOpen" @click="onClick" >
			<img class="bg" :src="game_config.you_have_mail_bg" />
			<div class="envelope">
				<img :src="game_config.you_have_mail_icon" />
			</div>
			<a class="haveMail">
				You have mail!
			</a>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import msEdgeImageSwap from '@/mixins/msEdgeImageSwap';

export default {
	name: 'ComputerAlert',
	props: ['isOpen'],
	mixins: [msEdgeImageSwap],
	computed: {
		...mapState({ // get data from wordpress Game Config page
			game_config: state => state.config.data.game_config,
		}),
	},
	methods: {
		onClick(e) {
			this.$emit('onClickComputerAlert', e);
		},
	},
	mounted() {
		this.swapEdgeImages();
	},
};
</script>

<style lang="scss" scoped>
	.component-container{
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
	}
	.computer-alert {
		width: 24%;
		height: 28.5%;
		position: absolute;
		left: 62.5%;
		top: 47.7%;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		cursor: pointer;
		overflow: hidden;
		.bg{
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			animation: alertAnim 0.5s ease-out 0s 1 normal forwards;
		}
		.haveMail{
				display: inline-block;
				background-color: red;
				color: white;
				padding: 5px 10px;
				border: 2px solid black;
				animation: blinking 1s infinite 2.2s;
				margin-top: 10px;
				opacity: 0;
				@include breakpoint(md){
					padding: 3px 10px;
				}
				@include breakpoint(sm){
					font-size: 0.9375em;
				}
				@include breakpoint(xsm){
					font-size: 0.875em;
					padding: 2px 8px;
				}
				@include breakpoint(xs){
					font-size: 0.75em;
					padding: 1px 8px;
				}
				&:hover{
					color: white;
				}
		}
		.envelope{
			width: 50%;
			height: auto;
			animation: envelopeAnim 1s ease-out 1s 1 normal forwards;
			transform: rotateY(180deg) translateY(200%);
			img{
				width: 100%;
				height: auto;
				display: block;
			}
		}
	}
	@keyframes alertAnim {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
	@keyframes envelopeAnim {
		from {
			transform: rotateY(180deg) translateY(150%);
		}
		to {
			transform: rotateY(0deg) translateY(0);
		}
	}
	@keyframes blinking {
		0% { opacity: 0; }
		20% { opacity: 1; }
		80% { opacity: 1; }
		100% { opacity: 0; }
	}
</style>



// WEBPACK FOOTER //
// src/components/abstract/ComputerAlert.vue